// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 453 ? "eef9e134" : chunkId) + "." + {"54":"35908394b9f89e3b","130":"05dbd70e3aba292e","172":"efa6dbf894fc7583","178":"6556961d1dfc90f1","453":"7e9867cf4fa5ef64","633":"a8b2b0771b487370","754":"9a572a6e55e120cb","822":"c6e68aa10e466ff5","975":"da22b701c285be82"}[chunkId] + ".js";
};